import { useRouter } from 'next/router';

const FOOD_PROGRAM_CTA_HREF = {
  en: 'https://calendly.com/food-program/15min',
  de: 'https://calendly.com/food-program/15min',
};

export function useFoodProgramCta() {
  const { locale } = useRouter();

  if (locale === 'en') {
    return FOOD_PROGRAM_CTA_HREF.en;
  }
  return FOOD_PROGRAM_CTA_HREF.de;
}
